// extracted by mini-css-extract-plugin
export default {"LocationsList":"LocationsList_LocationsList__i+Dj-","actions":"LocationsList_actions__fM4Hq"};